export default __webpack_public_path__ + "static/media/PANELES.7fc7d70d.jpg";